import React, { useCallback } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import { useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import './BrokerPulsCheckActions.styles.scss';

type BrokerPulsCheckActionsProps = {
  className?: string;
};

const BrokerPulsCheckActions: React.FC<BrokerPulsCheckActionsProps> = (
  props,
) => {
  const { className } = props;

  const classes = classNames('broker-puls-check-actions', className);

  const { t } = useTranslation();

  const { submitting } = useFormState();
  const { change, submit } = useForm();

  const onChange = useCallback(
    (skipMessage: boolean) => {
      change('skipMessage', skipMessage);
      submit();
    },
    [change, submit],
  );

  return (
    <div className={classes}>
      <Button disabled={submitting} onClick={() => onChange(false)}>
        {t('sendMessageToLeads')}
      </Button>

      <Button
        variant="link"
        disabled={submitting}
        onClick={() => onChange(true)}
      >
        {t('skip')}
      </Button>
    </div>
  );
};

export default BrokerPulsCheckActions;
